import { render } from "./DialogFormMineur.vue?vue&type=template&id=9723b71c&scoped=true"
import script from "./DialogFormMineur.vue?vue&type=script&lang=js"
export * from "./DialogFormMineur.vue?vue&type=script&lang=js"

import "./DialogFormMineur.vue?vue&type=style&index=0&id=9723b71c&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9723b71c"]])

export default __exports__